import { VoltageSpeedDashboardSample, VoltageSpeedVoltageChange } from '../../voltage-with-speed.models';
import { getTimelinePoints } from '../timeline/timeline.utils';
import { getVoltageEventTime } from '../voltage-anomalies/voltage-anomalies.utils';
import { VoltageSpeedDailyEvent } from './daily-events.models';

function validNumber(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : null;
}

export function buildDailyEvents(samples: VoltageSpeedDashboardSample[], changes: VoltageSpeedVoltageChange[]): VoltageSpeedDailyEvent[] {
  const points = getTimelinePoints(samples);
  const events: VoltageSpeedDailyEvent[] = [];
  for (let index = 1; index < points.length; index++) {
    const current = points[index];
    const previous = points[index - 1];
    if ((current.engine !== 0 && current.engine !== 1) || (previous.engine !== 0 && previous.engine !== 1)
      || current.engine === previous.engine || current.second === previous.second) continue;
    events.push({
      second: current.second,
      time: new Date(current.second * 1000).toISOString().slice(11, 19),
      title: current.engine === 1 ? 'ثبت روشن شدن موتور' : 'ثبت خاموش شدن موتور',
      speed: current.speed,
      voltage: current.voltage,
      description: 'تغییر وضعیت بین دو رکورد؛ زمان نمایش‌داده‌شده مربوط به ثبت وضعیت جدید است.'
    });
  }

  for (const change of changes) {
    const time = getVoltageEventTime(change.dtDateTime);
    if (time === '—') continue;
    const [hour, minute, second] = time.split(':').map(Number);
    const delta = typeof change.VoltageChange === 'number' && Number.isFinite(change.VoltageChange) ? change.VoltageChange : null;
    const previous = validNumber(change.PreviousVoltage);
    const interval = validNumber(change.IntervalSeconds);
    const details: string[] = [];
    if (previous !== null) details.push(`ولتاژ قبلی: \u2066${previous.toFixed(2)} V\u2069`);
    if (delta !== null) details.push(`تغییر: \u2066${delta > 0 ? '+' : ''}${delta.toFixed(2)} V\u2069`);
    if (interval !== null) details.push(`فاصله دو رکورد: \u2066${interval} s\u2069`);
    events.push({
      second: hour * 3600 + minute * 60 + second,
      time,
      title: delta === null ? 'تغییر ولتاژ' : delta > 0 ? 'افزایش ولتاژ' : delta < 0 ? 'افت ولتاژ' : 'بدون تغییر ولتاژ',
      speed: validNumber(change.iSpeed),
      voltage: validNumber(change.fPower),
      description: details.join(' · ') || 'رویداد گزارش‌شده توسط سرور'
    });
  }
  return events.sort((a, b) => a.second - b.second);
}
